var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3324(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.581,
    height: 26.09,
    viewBox: "0 0 30.581 26.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3324",
    "data-name": "Group 3324",
    transform: "translate(-671.676 -867.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M197.32,105.2h-2.975v-.786a.587.587,0,0,0-1.173,0v.786h-7.448v-.786a.587.587,0,0,0-1.173,0v.786h-2.975a2.449,2.449,0,0,0-2.447,2.447v15.012a2.449,2.449,0,0,0,2.447,2.447H197.32a2.449,2.449,0,0,0,2.447-2.447V107.642a2.449,2.449,0,0,0-2.447-2.447ZM180.3,107.642a1.275,1.275,0,0,1,1.274-1.273h2.975v.786a.587.587,0,0,0,1.173,0v-.786h7.448v.786h0a.587.587,0,0,0,1.173,0v-.786h2.975a1.275,1.275,0,0,1,1.274,1.273v3.542H180.3Zm17.018,16.288H181.576a1.275,1.275,0,0,1-1.274-1.276v-10.3h18.292v10.3a1.275,1.275,0,0,1-1.274,1.276Z",
    transform: "translate(492.797 763.722)",
    fill: "#333",
    stroke: "#323232",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(687.055 878.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M331.3,260.437a7.6,7.6,0,1,1-7.6-7.6,7.6,7.6,0,0,1,7.6,7.6",
    transform: "translate(-316.102 -252.836)",
    fill: "#95a7c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M398.358,327.092h-2.609v-2.67a.63.63,0,1,0-1.259,0v2.67h-2.609a.63.63,0,1,0,0,1.259h2.609V330.9a.63.63,0,1,0,1.259,0v-2.547h2.609a.63.63,0,1,0,0-1.259",
    transform: "translate(-387.309 -320.069)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3324);
export default __webpack_public_path__ + "static/media/Group 3324.30ca55f2bca74ff4b5f600bc876db269.svg";
export { ForwardRef as ReactComponent };